/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';

// custom imports
import {
  upperCaseFirstLetter,
  lowerCaseAllWordsExceptFirstLetters,
  handleScrollToEvent,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import { tabHighLigther } from '../../../SharedModules/utilities/utilities';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import * as constantMessageData from '../../../SharedModules/Errors/constantMessageData';
import SearchTypeComponent from '../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';

import TableGridWithFeatures from '../../../SharedModules/Table/TableGridWithFeatures';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../SharedModules/RadioGroup/RadioGroupBtn';
import {
  NDCTableHead,
  manufacturersTableHead,
} from './gridComponents/tableHead';
import {
  getNDCDetails,
  setNDCErrorPopupMessage,
  setNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
} from '../../Display/NDC/store/action';

import {
  selectionList,
  setMfgSelected,
  getAllManufacturerList,
  SearchScreenRedux,
  SearchScreenRedux1,
  selectByList,
  searchTypeList,
  getExistingRows,
  handleErrorMessages,
  getNDCByMfgId,
  getUnitConversionDetail,
  dispatchStatusBit,
  getNdcGrid,
  dispatchNdcGrid,
  dispatchGetNDCByMfgId,
  dispatchSuccessMessage,
  dispatchFirstTimeAdd,
  dispatchBottonState,
  setCMSUnitType,
} from './store/actions';

const UnitConversion1st = () => {
  const history = useHistory();
  const setSearchUnitConversion = (value) =>
    dispatch(SearchScreenRedux1(value));
  const dispatch = useDispatch();
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.errorMessagesInRedux
  );
  const getReduxValue1 = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.getReduxValue1
  );
  const searchCompObj = getReduxValue1?.state?.searchTypeState;
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const [fullScreenView, setFullScreenView] = useState(false);
  const [labelerFullScreen, setLabelerFullScreen] = useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setlabelerSelectedRow] = useState(
    searchCompObj?.labelerSelectedRowRedux
      ? searchCompObj?.labelerSelectedRowRedux
      : ''
  );
  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );

  const [ndcRightSelectedRows, setNdcRightSelectedRows] = useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] = useState(
    searchCompObj?.ndcLeftTableDataRedux
      ? searchCompObj?.ndcLeftTableDataRedux
      : []
  );
  const [ndcRightTableData, setNdcRightTableData] = useState(
    searchCompObj?.ndcRightTableDataRedux
      ? searchCompObj?.ndcRightTableDataRedux
      : []
  );
  const gridRef = React.useRef();
  const [gridParams, setGridParams] = useState('');
  const [ndcSearchVal, setNdcSearchVal] = useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );

  const [ndcNameSearchVal, setNdcNameSearchVal] = useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );
  const errorMessagesOfSearchTypeComp =
    errorMessagesFromRedux?.searchScreenErrors?.length > 0
      ? _.filter(
          errorMessagesFromRedux?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];

  const [searchType, setSearchType] = useState(
    searchCompObj?.valueSelectedRedux
      ? searchCompObj?.valueSelectedRedux
      : userDefaults?.defNdcSelectModeCd
      ? userDefaults?.defNdcSelectModeCd === 'NDC'
        ? 'NDC'
        : upperCaseFirstLetter(
            lowerCaseAllWordsExceptFirstLetters(
              userDefaults?.defNdcSelectModeCd
            )
          )
      : 'NDC'
  );
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = useState(
    errorMessagesOfSearchTypeComp
  );
  const [selectContact, setSelectContact] = React.useState(null);
  const [gridApi, setGridApi] = React.useState(null);
  const [arr2, setArr2] = React.useState([]);
  const [state, setState] = useState(
    getReduxValue1?.state
      ? getReduxValue1.state
      : {
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        }
  );
  // handing refresh functionality
  React.useEffect(() => {
    const searchObj = {
      valueSelectedRedux: searchType || 'NDC',
      ndcSearchTextRedux: ndcSearchVal || '',
      ndcNameSearchTextRedux: ndcNameSearchVal || '',
      ndcLeftTableDataRedux: ndcLeftTableData || [],
      ndcRightTableDataRedux: ndcRightTableData || [],
      labelerTableDataRedux: labelerTableData || [],
      ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
      ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
      labelerSelectedRowRedux: labelerSelectedRow || '',
      labelerFullScreenRedux: labelerFullScreen,
      ndcLeftFullScreenRedux: ndcLeftFullScreen,
      ndcRightFullScreenRedux: ndcRightFullScreen,
    };
    setState({ ...state, searchTypeState: searchObj });
    setSearchUnitConversion({
      fullScreenView: fullScreenView,
      state: { ...state, searchTypeState: searchObj },
    });
  }, [
    searchType,
    labelerSelectedRow,
    ndcLeftSelectedRows,
    ndcRightSelectedRows,
    labelerTableData,
    ndcLeftTableData,
    ndcRightTableData,
    ndcSearchVal,
    ndcNameSearchVal,
    labelerFullScreen,
    ndcLeftFullScreen,
    ndcRightFullScreen,
  ]);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  // handing full screen view
  React.useEffect(() => {
    if (labelerFullScreen || ndcLeftFullScreen || ndcRightFullScreen) {
      setFullScreenView(true);
      const searchObj = {
        valueSelectedRedux: searchType || 'NDC',
        ndcSearchTextRedux: ndcSearchVal || '',
        ndcNameSearchTextRedux: ndcNameSearchVal || '',
        ndcLeftTableDataRedux: ndcLeftTableData || [],
        ndcRightTableDataRedux: ndcRightTableData || [],
        labelerTableDataRedux: labelerTableData || [],
        ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
        ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
        labelerSelectedRowRedux: labelerSelectedRow || '',
        labelerFullScreenRedux: labelerFullScreen,
        ndcLeftFullScreenRedux: ndcLeftFullScreen,
        ndcRightFullScreenRedux: ndcRightFullScreen,
      };

      setSearchUnitConversion({
        fullScreenView: true,
        state: { ...state, searchTypeState: searchObj },
      });
    } else {
      setFullScreenView(false);
      setSearchUnitConversion({
        fullScreenView: false,
        state: state,
      });
    }
  }, [labelerFullScreen, ndcLeftFullScreen, ndcRightFullScreen]);

  const getErrorsFromSearchTypeComponent = (errors) => {
    if (errors.length > 0) {
      let alreadyPresentErrors = errorMessagesFromRedux?.searchScreenErrors
        ? errorMessagesFromRedux?.searchScreenErrors
        : [];

      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );

      alreadyPresentErrors = alreadyPresentErrors.concat(errors);

      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
      window.scrollTo(0, 0);
    }
  };
  React.useEffect(() => {
    const arr = [];
    if (ndcRightSelectedRows.length > 0) {
      ndcRightSelectedRows.filter((item) => {
        arr.push(item.drugSeqNum);
      });
    }

    setArr2(arr);
  }, [ndcRightSelectedRows]);

  const handleOnClick = async (data) => {
    dispatch(dispatchBottonState(true));
    dispatch(dispatchFirstTimeAdd(true));
    dispatch(setCMSUnitType({}));
    dispatch(dispatchStatusBit(1));
    await dispatch(
      getUnitConversionDetail({
        drugSeqNum: data.map((item) => {
          return item?.drugSeqNum;
        }),
      })
    );
  };
  return (
    <div
      className="tBillPanel custom-check tabs-container"
      data-testid="ProviderReview"
    >
      <div className="no-margin">
        <div className="row">
          <div className="col-sm-12">
            <SearchTypeComponent
              id="claimAuditSelect"
              data-testid="claim-audit-select-Ndc-Component"
              addDetailButtonname="Add Unit Conversion"
              searchType={searchType}
              setSearchType={setSearchType}
              getErrorsFromSearchTypeComponent={
                getErrorsFromSearchTypeComponent
              }
              errorMsgFromSearchType={errorMsgFromSearchType}
              setLabelerFullScreen={setLabelerFullScreen}
              labelerFullScreen={labelerFullScreen}
              setNdcLeftFullScreen={setNdcLeftFullScreen}
              ndcLeftFullScreen={ndcLeftFullScreen}
              setNdcRightFullScreen={setNdcRightFullScreen}
              ndcRightFullScreen={ndcRightFullScreen}
              handleViewDetailFunction={handleOnClick}
              setlabelerSelectedRow={setlabelerSelectedRow}
              labelerSelectedRow={labelerSelectedRow}
              setNdcLeftSelectedRows={setNdcLeftSelectedRows}
              ndcLeftSelectedRows={ndcLeftSelectedRows}
              setNdcRightSelectedRows={setNdcRightSelectedRows}
              ndcRightSelectedRows={ndcRightSelectedRows}
              setlabelerTableData={setlabelerTableData}
              labelerTableData={labelerTableData}
              setNdcLeftTableData={setNdcLeftTableData}
              ndcLeftTableData={ndcLeftTableData}
              setNdcRightTableData={setNdcRightTableData}
              ndcRightTableData={ndcRightTableData}
              setNdcSearchVal={setNdcSearchVal}
              ndcSearchVal={ndcSearchVal}
              setNdcNameSearchVal={setNdcNameSearchVal}
              ndcNameSearchVal={ndcNameSearchVal}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default UnitConversion1st;
